import classNames from "classnames"
import { UserOutlined } from "@ant-design/icons"
import { Flex, Tag, Typography } from "antd"
import { formatDateTimeMinute } from "~/common/utils"
import { levelLabel, levelTagColor } from "~/pages/Staff/labels"
import { getUserLevelCode } from "~/pages/Staff/useStaffUserLookup"
import styles from "./index.css"

const { Text } = Typography

type StaffUserCardProps = {
  className?: string
  expiryLabel: string
  user: API.Staff.StaffUser
}

export const StaffUserCard = ({
  className,
  expiryLabel,
  user,
}: StaffUserCardProps) => {
  const levelCode = getUserLevelCode(user)

  return (
    <Flex
      className={classNames(styles.userCard, className)}
      align="center"
      gap={14}
    >
      <UserOutlined className={styles.userIcon} />
      <Flex
        vertical
        gap={4}
      >
        <Flex
          align="center"
          gap={10}
        >
          <Text strong>用户手机号：{user.mobile}</Text>
          <Tag color={levelTagColor[levelCode]}>{levelLabel[levelCode]}</Tag>
        </Flex>
        <Text type="secondary">用户ID：{user.id}</Text>
        <Text type="secondary">
          {expiryLabel}：
          {formatDateTimeMinute(user.level_info?.level_effective_until)}
        </Text>
      </Flex>
    </Flex>
  )
}
